<!-- =========================================================================================
  File Name: uploads/ImageUpload.vue
  Description: Image Upload Form
========================================================================================== -->

<template>
  <!-- tab 1 content -->
  <form data-vv-scope="step-1">
    <vx-card>
      <!-- Space Thumbnail Upload -->
      <div class="mb-6">
        <h4 class="mb-4">Space Thumbnail</h4>
        <file-pond
          :imageResizeTargetWidth="200"
          :imagePreviewHeight="200"
          name="test"
          ref="pond"
          :label-idle="this.$t('HoverpackImageDrag')"
          :server="{ process, revert, restore, load, fetch }"
          :allow-multiple="false"
          accepted-file-types="image/jpeg, image/png"
          :files="file"
          v-on:removefile="onFileRemoved"
          v-on:addfile="onFileAdded"
          v-on:init="handleFilePondInit"
        />
        <span class="text-danger">{{ errors.first('step-1.image_upload') }}</span>
        <span v-if="errorMessageUpload" class="text-danger">{{ errorMessageUpload }}</span>
      </div>
    </vx-card>
    <vx-card v-if="layerHomePageType == 'map'" class="margin-top">
    <!-- Card Title -->
    <div class="mb-6">
      <h4 class="mb-4">Space Card</h4>
      <label class="vs-input--label">Card Title</label>
      <vs-input
        v-model="space.card_title"
          @input="onCardTitleChanged"
          placeholder="Enter card title"
          class="w-full"
        />
      </div>

      <!-- Card Description -->
      <div class="mb-4">
        <label class="vs-input--label">Card Description</label>
        <vs-textarea
          v-model="space.card_description"
          @input="onCardDescriptionChanged"
          placeholder="Enter card description"
          class="w-full"
        />
      </div>

      <!-- Card Image Upload -->
      <div class="mb-4">
        <h4 class="mb-4">Card Image</h4>
        <file-pond
          :imageResizeTargetWidth="200"
          :imagePreviewHeight="200"
          name="card_image"
          ref="cardImagePond"
          label-idle="Drop card image here or click to browse"
          :server="{ process: processCardImage, revert, restore, load, fetch }"
          :allow-multiple="false"
          accepted-file-types="image/jpeg, image/png"
          :files="cardImageFile"
          v-on:removefile="onCardImageRemoved"
          v-on:addfile="onCardImageAdded"
        />
        <span v-if="errorMessageCardImage" class="text-danger">{{ errorMessageCardImage }}</span>
      </div>
    </vx-card>
  </form>
</template>

<script>
// Import Vue FilePond
import vueFilePond from 'vue-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'

import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImageTransform from 'filepond-plugin-image-transform'
import FilePondPluginImageResize from 'filepond-plugin-image-resize'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import imageCompression from 'browser-image-compression'
import * as HoverlayUtils from '@/assets/js/utils/hoverlay-utils.js'

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginImageExifOrientation,
  FilePondPluginImageResize,
  FilePondPluginImageTransform
)

export default {
  inject: ['$validator'],
  components: {
    FilePond,
  },
  props: {
    space: {},
  },
  data() {
    return {
      // inherited variables from parent
      errorMessageUpload: '',
      file: [],
      cardImageFile: [],
      errorMessageCardImage: '',
    }
  },
  watch: {
    space: {
      handler: function() {},
      deep: true,
    },
  },
  computed: {
    layerHomePageType() {
      return HoverlayUtils.getLayerHomePageType()
    },
  },
  created() {
    console.log('uploads/ImageUpload.vue created ')
    console.log(this.space)
    var dataUrl = null
    if (this.space.thumbnail) dataUrl = this.space.thumbnail
    if (dataUrl)
      this.file = [
        {
          source: dataUrl,
          options: {
            type: 'local',
          },
        },
      ]

    // Initialize card image
    var cardImageDataUrl = null
    if (this.space.card_image) cardImageDataUrl = this.space.card_image
    if (cardImageDataUrl)
      this.cardImageFile = [
        {
          source: cardImageDataUrl,
          options: {
            type: 'local',
          },
        },
      ]
  },
  methods: {
    removeThumbnail() {
      this.space.thumbnail = false
    },
    onFileRemoved(error, file) {
      console.log('fileRemoved')
      this.removeThumbnail()
    },
    onFileAdded(error, file) {
      console.log('onFileAdded')
    },
    handleFilePondInit() {
      console.log('FilePond has initialized')
      // FilePond instance methods are available on `this.$refs.pond`
    },
    validate() {
      if (this.hobject.image || this.file.length > 0) {
        this.errorMessageUpload = ''
        console.log('[ImageUpload.vue] VALIDATION TRUE')
        return true
      } else {
        console.log('[ImageUpload.vue] VALIDATION FALSE')
        this.errorMessageUpload = 'You must upload an image'
        return false
      }
    },
    async process(fieldName, file, metadata, load, error, progress, abort) {
      console.log('process')
      const resizeOptions = {
        maxSizeMB: 1,
        maxWidthOrHeight: 960,
        useWebWorker: true,
      }
      const compressedImage = await imageCompression(new File([file], file.name, { type: file.type }), resizeOptions)
      this.space.thumbnail = compressedImage
      console.log(this.space)
      load(file)
      // Should expose an abort method so the request can be cancelled
      return {
        abort: () => {
          // Let FilePond know the request has been cancelled
          abort()
        },
      }
    },
    load(source, load, error, progress, abort, headers) {
      var myRequest = new Request(source)
      fetch(myRequest).then(function(response) {
        response.blob().then(function(myBlob) {
          load(myBlob)
        })
      })
    },

    fetch(url, load, error, progress, abort, headers) {
      var myRequest = new Request(url)
      fetch(myRequest).then(function(response) {
        response.blob().then(function(myBlob) {
          load(myBlob)
        })
      })
    },

    restore(uniqueFileId, load, error, progress, abort, headers) {
      // error();
    },

    revert(uniqueFileId, load, error) {
      // load();
    },

    // Methods for handling new card fields
    onCardTitleChanged() {
      // Card title change is automatically handled by v-model
    },

    onCardDescriptionChanged() {
      // Card description change is automatically handled by v-model
    },

    removeCardImage() {
      this.space.card_image = false
    },

    onCardImageRemoved(error, file) {
      console.log('cardImageRemoved')
      this.removeCardImage()
    },

    onCardImageAdded(error, file) {
      console.log('onCardImageAdded')
    },

    async processCardImage(fieldName, file, metadata, load, error, progress, abort) {
      console.log('processCardImage')
      const resizeOptions = {
        maxSizeMB: 1,
        maxWidthOrHeight: 960,
        useWebWorker: true,
      }
      const compressedImage = await imageCompression(new File([file], file.name, { type: file.type }), resizeOptions)
      this.space.card_image = compressedImage
      console.log('Card image processed:', this.space)
      load(file)

      return {
        abort: () => {
          abort()
        },
      }
    },
  },
}
</script>

<style lang="scss">
.margin-top {
  margin-top: 25px;
}

.image-preview {
  height: 220px;
  width: 220px;
}
</style>
